import { __ } from '@wordpress/i18n';

export const ANGIE_GUIDE_TOGGLE_EVENT = 'elementor/editor/toggle-angie-guide';
export const CREATE_WIDGET_EVENT = 'elementor/editor/create-widget';

export const ANGIE_BUTTON_ARIA_LABEL = __( 'Angie', 'elementor' );

export const ANGIE_PROMOTION_IMAGE_URL = 'https://assets.elementor.com/packages/v1/images/angie-promotion.svg';

export const ANGIE_LEARN_MORE_URL = 'https://go.elementor.com/angie-learn-more';

export const ANGIE_DESCRIPTION = __(
	'Angie lets you generate custom widgets, sections, and code using simple instructions.',
	'elementor'
);

export const AI_WIDGET_CTA_VIEWED_EVENT = 'ai_widget_cta_viewed' as const;
export const ANGIE_TOP_BAR_PROMOTION_IMAGE_URL =
	'https://assets.elementor.com/packages/v1/images/angie-top-bar-promotion.svg';
export const ANGIE_TOP_BAR_DESCRIPTION = __( 'Build custom widgets using simple instructions.', 'elementor' );
